import { createReducer } from '@reduxjs/toolkit';
import {
  getUser,
  getUserFail,
  getUserSuccess,
  setIsNotified,
  signUp,
  signUpFail,
  signUpSuccess,
} from './appActions';
import { AppState } from './appModel';

export const initialState: AppState = {
  isNotified: false,
  isLoading: false,
};

const appReducer = createReducer(initialState, (builder) => {
  builder
    .addCase(setIsNotified, (state: AppState, action) => {
      state.isNotified = action.payload.isNotified;
    })
    .addCase(getUser, (state: AppState) => {
      state.isLoading = true;
    })
    .addCase(getUserFail, (state: AppState) => {
      state.isLoading = false;
    })
    .addCase(getUserSuccess, (state: AppState, action) => {
      state.user = action.payload.user;
      state.isLoading = false;
    })
    .addCase(signUp, (state: AppState) => {
      state.isLoading = true;
      state.showSignUpError = false;
    })
    .addCase(signUpFail, (state: AppState) => {
      state.isLoading = false;
      state.showSignUpError = true;
    })
    .addCase(signUpSuccess, (state: AppState) => {
      state.isLoading = false;
    });
});

export default appReducer;
